'use client';

import { forwardRef } from 'react';

import { Icon } from '../icon/icon';
import { adornedInputIconStyles } from './styles/adorned-input-icon.styles';
import type { AdornedInputIconPropsInterface } from './types/adorned-input-icon.types';

/**
 * @since 10.0.0
 */
export const AdornedInputIcon = forwardRef<SVGSVGElement, AdornedInputIconPropsInterface>(
  (props: AdornedInputIconPropsInterface, forwardedRef) => {
    const { children, css: cssProp, ...rest } = props;

    return (
      <Icon
        data-c11n-component="AdornedInput.Icon"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        css={{
          ...adornedInputIconStyles,
          ...cssProp,
        }}
        {...rest}
      >
        {children}
      </Icon>
    );
  },
);

AdornedInputIcon.displayName = 'AdornedInput.Icon';
